
import { DateTime } from "luxon";

export const getTimeZoneStandard = (time) => {
    const offset = -1 * new Date().getTimezoneOffset()
    const dateTZ = DateTime.fromISO(time).toUTC(offset)
    return (dateTZ.toFormat("yyyy-MM-dd'T'HH:mm:ss"))
  }
  
  export const getTimeZoneStandardInteger = (time) => {
    const offset = -1 * new Date().getTimezoneOffset() / 60
  
    if (time + offset === 24) {
      return 0
    }
  
    return time + offset
  }
  
  
  export const getTimeZoneLondon = (time) => {
    const dateTZ = DateTime.fromISO(time).toUTC(0)
    return (dateTZ.toFormat("yyyy-MM-dd'T'HH:mm:ss"))
  }